import Axios from 'axios';
const http = Axios.create({
  withCredentials: true,
});

http.interceptors.response
  .use(
    response => response,
    (error) => {
      let isLoginError = false;
      if (error.response && error.response.data && error.response.data.error) {
        isLoginError = error.response.data.error.indexOf("login_failed") != -1
      }

      // ステータスコード:401でログインエラー以外の認証エラーの場合はログイン画面に戻る
      if(error.response.status == 401 && !isLoginError){
        const url = window.location.href;
        if(url.indexOf("student_site") != -1){
          // 生徒サイトのログイン画面へ          
          const ary = url.split("/");
          const index = ary.indexOf("#") + 1;

          if(ary.length < index + 1 || ary[index] == null || ary[index] == undefined){
            alert("エラーが発生しました。\n一度ブラウザを閉じてから再度ログインページにアクセスしてください。");
          }else{
            window.location.href = `/#/${ary[index]}/student_site/sign_in`;
          }
        }else if(url.indexOf("digital_paper_site") != -1){
          // デジタルペーパーサイトのログイン画面へ
          window.location.href = "/#/digital_paper_site/sign_in?errorKind=session_timeout";
        }else if(url.indexOf("candidate") != -1){
          window.location.href = "/#/candidate/sign_out";
        }else{
          // 教師サイトログイン画面へ
          window.location.href="/#/";
        }
        return;
      }else if(error.response.status == 500){
        if(error.response.data.errors !== undefined && error.response.data.stack !== undefined){
          console.log(error.response.data.errors[0]);
          console.log(error.response.data.stack);
        }
      }
      return Promise.reject(error);
    });

export default http;
